import { createFileRoute } from '@tanstack/react-router';
import { Wallet } from '@/features/wallet';

export const Route = createFileRoute('/_authenticated/wallet/')({
    head: () => ({ meta: [{ title: 'Wallet | promote.fun' }] }),
    component: Wallet,
});
